import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom"
import axios from 'axios'

const Nav = ({ getKategori }) => {
    const [data, setData] = useState([])

    useEffect(() => {
        getData()
    }, [])

    const getData = async () => {
        try {
            // Sesuaikan endpoint-nya ke publish grup/klaster utama
            const response = await axios.post("/api/csr/portal/group", {})
            setData(response.data)
        } catch (err) {
            console.error("Gagal ambil nav:", err)
        }
    }

    return (
        <ul className="dropdown-menu bg-primary w-300 pb-15">
            <li className="dropdown-header">
                <h4 className='color-warning'>Klaster TJSL</h4>
            </li>
            {data.map((val, i) => {
                // 1. Ganti grupName jadi klaster (sesuai JSON respon lu)
                if (!val || !val.klaster) return null;

                // 2. Slug pake val.klaster
                const slug = val.klaster.toLowerCase().replaceAll(' ', '-').replaceAll('/', '_');

                return (
                    <React.Fragment key={i}>
                        <li key={val.categoryName} role="separator" className="dropdown-divider"></li>
                        <li key={i}>
                            <Link to={`/csr-katalog/${slug}`} className='dropdown-item d-flex align-items-center' onClick={(e) => { getKategori(slug, '') }}>
                                {val.klaster}
                            </Link>
                        </li>
                    </React.Fragment>
                )
            })}
        </ul>
    )
}

export default Nav